import styled from 'styled-components'
import {
  Modal,
  OrderedBreadcrumbs as OrderedBreadcrumbsUnstyled,
  Separator as SeparatorUnstyled,
} from '@sketch/components'
import { ReactComponent as ExclamationMark } from '@sketch/icons/exclamation-mark-triangle-64'
import { breakpoint } from '@sketch/global-styles'

export const ModalStyled = styled(Modal)`
  max-width: 640px;
  height: 688px;
  overflow: hidden;
  position: relative;
`

export const CreatePreviewContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

export const StepContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  flex-shrink: 1;
  position: relative;
`

export const TabContentContainer = styled.div`
  padding: 16px 24px;
`

export const ErrorIcon = styled(ExclamationMark)`
  flex: none;
  width: 64px;
  height: 64px;
  opacity: 0.55;
`

export const OrderedBreadcrumbs = styled(OrderedBreadcrumbsUnstyled)`
  margin-bottom: 16px;

  ${breakpoint('base', 'xs')`
    margin-top: 0px;
  `}
`

export const FullWidthSeparator = styled(SeparatorUnstyled)`
  /* Extend separator to full modal width by negating Modal.Body padding */
  margin-left: -16px;
  margin-right: -16px;

  ${breakpoint('sm')`
    margin-left: -32px;
    margin-right: -32px;
  `}
`

export const EditModalHeader = styled(Modal.Header)`
  ${breakpoint('sm')`
      padding: 16px 24px 0;
    `}
`

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: ${({ theme }) => theme.fontSizes.E};
  font-weight: 400;
  line-height: 1.2;
`
